/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
    Blockly.Arduino.lcd = {};
    Blockly.Language || (Blockly.Language = {});

    function setupLCD() {
        // this code uses 3rd party libraries
        Blockly.Arduino.definitions_.define_lcd || (Blockly.Arduino.definitions_.define_wire = "#include <Wire.h>", Blockly.Arduino.definitions_.define_lcd = '#include "LiquidCrystal_I2C.h"');
        Blockly.Arduino.definitions_.var_lcd || (Blockly.Arduino.definitions_.var_lcd = "LiquidCrystal_I2C lcd(0x27, 16, 2);");
        Blockly.Arduino.setups_.setup_lcd || (Blockly.Arduino.setups_.setup_lcd = "  lcd.begin();\n  lcd.noCursor();\n  lcd.backlight();\n")
    }

    Blockly.Arduino.lcd_customchar = function() {
        var a = this.getFieldValue("NUM");
        --a;
        var b = this.getFieldValue("DATA");
        "" != b && (Blockly.Arduino.definitions_["var_lcd_customchar_" + a] = "byte lcd_customchar_" + a + "[8] = {" + b + "};", 
                    Blockly.Arduino.setups_["setup_lcd_customchar_" + a] = "  lcd.createChar(" + a + ", lcd_customchar_" + a + ");");
        return ""
    };

    Blockly.Arduino.lcd_begin_i2c = function() {
        // this code uses 3rd party libraries
        var a = this.getFieldValue("ADDR"),
            b = this.getFieldValue("SIZE"),
            c = "16",
            d = "2";
        "2x16" == b && (c = "16", d = "2");
        "4x20" == b && (c = "20", d = "4");
        Blockly.Arduino.definitions_.define_wire = "#include <Wire.h>";
        Blockly.Arduino.definitions_.define_lcd = '#include "LiquidCrystal_I2C.h"';
        Blockly.Arduino.definitions_.var_lcd = "LiquidCrystal_I2C lcd(" + a + ", " + c + ", " + d + ");";
        Blockly.Arduino.setups_.setup_lcd = "  lcd.begin();\n  lcd.noCursor();\n  lcd.backlight();\n";
        return ""
    };
    Blockly.Arduino.lcd_print = function() {
        setupLCD();
        var a = this.getFieldValue("CURSOR_COLUMN"),
            b = this.getFieldValue("CURSOR_ROW"),
            c = Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_UNARY_POSTFIX) || "''";
        return "lcd.setCursor(" + a + ", " + b + ");\nlcd.print(" + c + ");\n"
    };
    Blockly.Arduino.lcd_print_customchar = function() {
        setupLCD();
        var a = this.getFieldValue("CURSOR_COLUMN"),
            b = this.getFieldValue("CURSOR_ROW"),
            c = this.getFieldValue("NUM");
        --c;
        var d = "";
        Blockly.Arduino.definitions_["var_lcd_customchar_" + c] && (d = "lcd.setCursor(" + a + ", " + b + ");\nlcd.write((uint8_t)" + c + ");\n");
        return d
    };
    Blockly.Arduino.lcd_print2 = function() {
        setupLCD();
        var a = Blockly.Arduino.valueToCode(this, "CURSOR_COLUMN", Blockly.Arduino.ORDER_ATOMIC) || "0",
            b = Blockly.Arduino.valueToCode(this, "CURSOR_ROW", Blockly.Arduino.ORDER_ATOMIC) || "0",
            c = Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_UNARY_POSTFIX) || "''";
        20 <= a && (a = 19);
        0 > a && (a = 0);
        4 <= b && (b = 3);
        0 > b && (a = 0);
        return "lcd.setCursor(" + a + ", " + b + ");\nlcd.print(" + c + ");\n"
    };
    Blockly.Arduino.lcd_print2_customchar = function() {
        setupLCD();
        var a = Blockly.Arduino.valueToCode(this, "CURSOR_COLUMN", Blockly.Arduino.ORDER_ATOMIC) || "0",
            b = Blockly.Arduino.valueToCode(this, "CURSOR_ROW", Blockly.Arduino.ORDER_ATOMIC) || "0",
            c = this.getFieldValue("NUM");
        --c;
        20 <= a && (a = 19);
        0 > a && (a = 0);
        4 <= b && (b = 3);
        0 > b && (a = 0);
        var d = "";
        Blockly.Arduino.definitions_["var_lcd_customchar_" + c] && (d = "lcd.setCursor(" + a + ", " + b + ");\nlcd.write((byte)" + c + ");\n");
        return d
    };
    Blockly.Arduino.lcd_clear = function() {
        setupLCD();
        return "lcd.clear();\n"
    };
    Blockly.Arduino.lcd_display = function() {
        setupLCD();
        return "off" == this.getFieldValue("DISPLAY") ? "lcd.noDisplay();\n" : "lcd.display();\n"
    };
    Blockly.Arduino.lcd_backlight = function() {
        setupLCD();
        return "off" == this.getFieldValue("BACKLIGHT") ? "lcd.noBacklight();\n" : "lcd.backlight();\n"
    };
    Blockly.Arduino.lcd_cursor = function() {
        setupLCD();
        var a = this.getFieldValue("CURSOR");
        var b = "off" == a ? "lcd.noCursor();\n" : "lcd.cursor();\n";
        a = this.getFieldValue("BLINK");
        return "off" == a ? b + "lcd.noBlink();\n" : b + "lcd.blink();\n"
    };
    Blockly.Arduino.lcd_scroll = function() {
        setupLCD();
        return "left" == this.getFieldValue("DIR") ? "lcd.scrollDisplayLeft();\n" : "lcd.scrollDisplayRight();\n"
    };
    Blockly.Arduino.lcd_drawchar = function() {
        setupLCD();
        var col = this.getFieldValue("CURSOR_COLUMN"),
            row = this.getFieldValue("CURSOR_ROW"),
            count = Blockly.Arduino.lcd_count;
        var code = "";
        // Definitions
        for (var d = 0; 8 > d; d++) {
            for (var e = "  B", f = 0; 5 > f; f++) {
                e = "TRUE" == this.getFieldValue("R" + d.toString() + "C" + f.toString()) ? e + "1" : e + "0";
            }
            code += e;
            7 <= d && 7 <= f || (code += ",\n")
        }
        Blockly.Arduino.definitions_["var_lcd_customchar_" + count] = 
            "static const uint8_t lcd_customchar_" + count + "[] = {\n" + code + "};";
        Blockly.Arduino.lcd_count++;
        // Setups
        Blockly.Arduino.setups_["setup_lcd_customchar_" + count] = "  lcd.createChar((uint8_t)" + count + ", lcd_customchar_" + count + ");";
        // Code
        code = "lcd.setCursor(" + col + ", " + row + ");\nlcd.write((uint8_t)" + count + ");\n";
        return code;
    };
}